/* tslint:disable */
/* eslint-disable */
// Kézzel karbantartva: Backend.Core.Infrastructure.Aggregates.App.IssueReportArea (hibajelzés területe)
export enum IssueReportArea {
  Portal = 10,
  MobileApp = 20
}
